import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleInteraction extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M5,7.5V7C4.3,6.5,3.8,5.7,3.8,4.7c0-1.5,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8c0,0.6-0.2,1.2-0.5,1.7c0.2,0.1,0.4,0.2,0.5,0.3
					c0.4-0.6,0.6-1.2,0.6-2c0-1.9-1.5-3.4-3.4-3.4S3.2,2.8,3.2,4.7C3.2,6,3.9,7,4.9,7.6C4.9,7.6,5,7.6,5,7.5z"
          />
          <path
            d="M8.8,4.7c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2c0,0.6,0.2,1.1,0.6,1.5V4.8c0-0.1,0-0.3,0-0.4c0.1-0.7,0.8-1.3,1.6-1.3
					c0.8,0,1.4,0.6,1.6,1.3c0,0.1,0,0.3,0,0.4v1.4C8.6,5.8,8.8,5.3,8.8,4.7z"
          />
          <path
            d="M11.4,8.1c-0.2,0-0.3,0-0.5,0.1c-0.1-0.5-0.5-0.8-1.1-0.8c-0.2,0-0.4,0-0.5,0.1C9.2,7.1,8.8,6.8,8.2,6.8
					c-0.2,0-0.4,0-0.5,0.1v-2c0-0.6-0.5-1.1-1.1-1.1S5.5,4.2,5.5,4.8v3.1C5,8,4.4,8.5,4.4,9v2.6l0,0c0,0.1,0.1,1.8,1.8,2.7l0,0
					c0.5,0.3,1.4,0.4,2.3,0.4c0,0,0,0,0,0c0.7,0,1.8-0.1,2.6-0.7c0.9-0.5,1.3-1.4,1.3-2.5l0-2.5C12.4,8.5,12,8.1,11.4,8.1z M11.8,11.6
					c0,0.9-0.3,1.6-1,2c-0.6,0.4-1.4,0.6-2.3,0.6c0,0,0,0,0,0c-0.8,0-1.5-0.1-2-0.4C5.1,13,5,11.7,5,11.6V9c0-0.2,0.2-0.4,0.5-0.5v1.9
					h0.6V8.2V4.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.9v0.1v1.7h0.6V7.8c0-0.3,0.3-0.4,0.5-0.4s0.5,0.1,0.5,0.4v0.6v0.1v1h0.6v-1
					C9.4,8.2,9.6,8,9.9,8s0.5,0.1,0.5,0.4V9v0.1v0.4H11V9.1c0-0.3,0.2-0.4,0.4-0.4c0.2,0,0.4,0.1,0.4,0.4L11.8,11.6z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleInteraction.js